import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';
const BENTUK = ['PT', 'CV', 'Yayasan', 'Firma', 'Koperasi', 'Lainnya'];

export default function DaftarPerusahaan({ onSelectCompany }) {
  const [list, setList] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ username: '', password: '', nama_perusahaan: '', bentuk_badan: 'PT' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { loadList(); }, []);

  const loadList = async () => {
    try {
      const res = await axios.get(`${API}/api/admin/companies`);
      setList(res.data);
    } catch {}
  };

  const handleCreate = async (e) => {
    e.preventDefault(); setSaving(true); setMsg('');
    try {
      await axios.post(`${API}/api/admin/companies`, form);
      setMsg('Akun perusahaan berhasil dibuat!');
      setShowForm(false);
      setForm({ username: '', password: '', nama_perusahaan: '', bentuk_badan: 'PT' });
      loadList();
    } catch (err) {
      setMsg(err.response?.data?.detail || 'Gagal membuat akun');
    } finally { setSaving(false); }
  };

  const handleDelete = async (cid) => {
    if (!window.confirm('Hapus perusahaan ini beserta semua datanya?')) return;
    await axios.delete(`${API}/api/admin/companies/${cid}`);
    loadList();
  };

  return (
    <div>
      <div style={s.header}>
        <h2 style={s.h2}>🏛️ Semua Perusahaan</h2>
        <button style={s.addBtn} onClick={() => setShowForm(!showForm)}>+ Tambah Perusahaan</button>
      </div>
      {msg && <div style={{ ...s.msg, color: msg.includes('berhasil') ? '#16a34a' : '#dc2626' }}>{msg}</div>}

      {showForm && (
        <div style={s.formCard}>
          <h3 style={s.formTitle}>Buat Akun Perusahaan Baru</h3>
          <form onSubmit={handleCreate}>
            <div style={s.row}>
              <div style={{ flex: 2 }}>
                <label style={s.label}>Nama Perusahaan</label>
                <input style={s.input} value={form.nama_perusahaan} onChange={e => setForm(f => ({ ...f, nama_perusahaan: e.target.value }))} required placeholder="Nama PT / CV..." />
              </div>
              <div style={{ flex: 1 }}>
                <label style={s.label}>Bentuk Badan</label>
                <select style={s.input} value={form.bentuk_badan} onChange={e => setForm(f => ({ ...f, bentuk_badan: e.target.value }))}>
                  {BENTUK.map(b => <option key={b}>{b}</option>)}
                </select>
              </div>
            </div>
            <div style={s.row}>
              <div style={{ flex: 1 }}>
                <label style={s.label}>Username Login</label>
                <input style={s.input} value={form.username} onChange={e => setForm(f => ({ ...f, username: e.target.value }))} required placeholder="username" />
              </div>
              <div style={{ flex: 1 }}>
                <label style={s.label}>Password</label>
                <input style={s.input} type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required placeholder="password" />
              </div>
            </div>
            <div style={s.formActions}>
              <button type="button" style={s.cancelBtn} onClick={() => setShowForm(false)}>Batal</button>
              <button type="submit" style={s.saveBtn} disabled={saving}>{saving ? 'Membuat...' : 'Buat Akun'}</button>
            </div>
          </form>
        </div>
      )}

      {list.length === 0 ? (
        <div style={s.empty}>Belum ada perusahaan terdaftar. Klik "+ Tambah Perusahaan" untuk menambahkan.</div>
      ) : (
        <div style={s.grid}>
          {list.map(({ company, user }) => (
            <div key={company.id} style={s.card}>
              <div style={s.cardHeader}>
                <div style={s.bentukBadge}>{company.bentuk_badan}</div>
                <button style={s.delBtn} onClick={() => handleDelete(company.id)}>Hapus</button>
              </div>
              <div style={s.compName}>{company.nama_perusahaan}</div>
              <div style={s.userInfo}>👤 {user?.username}</div>
              <div style={s.createdAt}>Dibuat: {new Date(company.created_at).toLocaleDateString('id-ID')}</div>
              <button style={s.manageBtn} onClick={() => onSelectCompany(company.id)}>Kelola Data →</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  h2: { fontSize: '20px', fontWeight: '700', color: '#1a1a2e', margin: 0 },
  addBtn: { padding: '8px 18px', background: '#1a1a2e', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' },
  msg: { padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px', background: '#f0fdf4' },
  formCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  formTitle: { fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#1a1a2e' },
  row: { display: 'flex', gap: '12px', marginBottom: '12px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '5px' },
  input: { width: '100%', padding: '9px 12px', border: '1.5px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
  formActions: { display: 'flex', gap: '10px', justifyContent: 'flex-end' },
  cancelBtn: { padding: '8px 18px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  saveBtn: { padding: '8px 18px', background: '#1a1a2e', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '16px' },
  card: { background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' },
  bentukBadge: { background: '#eff6ff', color: '#1d4ed8', borderRadius: '6px', padding: '3px 10px', fontSize: '12px', fontWeight: '700' },
  compName: { fontSize: '16px', fontWeight: '700', color: '#1a1a2e', marginBottom: '8px', lineHeight: 1.3 },
  userInfo: { fontSize: '13px', color: '#6b7280', marginBottom: '4px' },
  createdAt: { fontSize: '12px', color: '#9ca3af', marginBottom: '14px' },
  manageBtn: { width: '100%', padding: '8px', background: '#f0fdf4', color: '#16a34a', border: '1.5px solid #bbf7d0', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' },
  delBtn: { padding: '4px 10px', background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' },
  empty: { background: 'white', borderRadius: '12px', padding: '40px', textAlign: 'center', color: '#9ca3af', fontSize: '14px' }
};
